import React from 'react';

export const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-full"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="#252525"
      d="M23.38 21.62l-6.52-6.53a9.28 9.28 0 10-1.77 1.77l6.53 6.53a1.27 1.27 0 001.76 0 1.25 1.25 0 000-1.77zM2.75 9.5a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0z"
    />
  </svg>
);
